var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('gmap-map',{staticStyle:{"width":"100%","height":"450px"},attrs:{"center":_vm.center,"zoom":12,"options":_vm.options}},_vm._l((_vm.markers),function(m,index){return _c('gmap-marker',{key:index,attrs:{"position":m.position},on:{"click":function($event){_vm.center=m.position}}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }